<template>
  <div>
    <alert-banner v-if="bannerType" :status="HelperStatus.Warn">{{ bannerMessage }}</alert-banner>
  </div>
</template>

<script lang="ts">
import HelperStatus from '@/helpers/status';
import { BannerType } from '../__types__/ErrorTypes.ts';
import AlertBanner from '@/components/alert_banner/AlertBanner.vue';

export default {
  name: 'ProviderProfileBanner',
  components: {
    AlertBanner,
  },
  props: {
    bannerType: {
      type: String,
      default: BannerType.NONE,
    },
  },
  data(): any {
    return {
      HelperStatus,
      BannerType,
    };
  },
  computed: {
    bannerMessage(): string {
      if (this.bannerType === BannerType.PROFILE_HIDDEN) {
        return 'This profile is hidden';
      }

      if (this.bannerType === BannerType.ACCOUNT_NOT_FOUND) {
        return 'This profile no longer exists';
      }

      return '';
    },
  },
};
</script>
